
export const DUREES = [
  {id: 0, description: "Jour(s)"}, 
  {id: 1, description: "Mois"}, 
  {id: 2, description: "Année(s)"}, 
]
export const ORDRE_TRI = [
  {id: 0, description: "Description d'unités"}, 
  {id: 1, description: "Types d'unités"}, 
]